module.exports = __webpack_public_path__ + "img/rise-4@3x.048a9894.png";